import { is } from 'stdlib/is'

/**
 * Fallback beállítása.
 * @param container   - Maga az Element.
 * @param fallbackSrc - A fallback src-je.
 */
export default function fallback (container: HTMLElement, fallbackSrc?: string): void {
  const hasFallback = (
    is.instanceOf(container, HTMLImageElement) &&
    is.string(fallbackSrc)
  )

  if (!hasFallback) {
    return
  }

  container.style.opacity = '1'
  container.src = fallbackSrc
}
